import { z } from 'zod';
export const applyReferralSchema = z.object({
    referralCode: z
        .string({
        required_error: 'Referral code is required.',
    })
        .trim()
        .min(1, 'Referral code cannot be empty.'),
});
//# sourceMappingURL=referral.schemas.js.map